import React from "react";
import { Switch, Route, Redirect } from "react-router-dom"
import Homepage from '.././pages/homepage';
import PrivacyPolicy from '.././pages/privacy_policy';
import TermsConditions from '.././pages/terms_conditions';


export const Routes = {
    Homepage: '/',
    PrivacyPolicy: '/privacy_policy',
    TermsAndConditions: '/terms_and_conditions'
}

export const RouterMatcher =
    <Switch>
        <Route exact path={Routes.PrivacyPolicy} component={PrivacyPolicy} />
        <Route exact path={Routes.TermsAndConditions} component={TermsConditions} />
        <Route exact path={Routes.Homepage} component={Homepage} />
        <Redirect to={Routes.Homepage} />
    </Switch>
